import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/components/SiteInner/home/home.vue'
import login from '@/components/login.vue'
import Swal from 'sweetalert2';
import { isTokenExpired, getTokenFromLocalStorage,removeTokenFromLocalStorage } from '@/tools/tokenStatus.js';
import { ElNotification } from 'element-plus'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    components: {
      login: login
    }
  },
  {
    path: '/ud-logs',
    component:  () => import("@/components/SiteInner/doc_logs/updatelogs.vue"),
  }
  ,
  {
    path: '/news',
    name: 'Arcnix News',
    //redirect: "/news/index",//默认加载某个页面
    children: [
      {
        //二级导航路径不要加 /
        path: "newstype",
        component:  () => import("@/components/SiteInner/news/newsType.vue"),
      },
      {
        path: "newslist",
        component: () => import("@/components/SiteInner/news/newsList.vue")
      },
      {
        path: "mdfnews",
        component: () => import("@/components/SiteInner/news/mdfNews.vue")
      },
      {
        path: "addnews",
        component: () => import("@/components/SiteInner/news/addNews.vue")
      }
    ]
  },
  {
    path: '/os',
    name: 'Arcnix 会员服务',
    //redirect: "/news/index",//默认加载某个页面
    children: [
      {
        //二级导航路径不要加 /
        path: "ostype",
        component:  () => import("@/components/SiteInner/opensource/opensourceType.vue"),
      },
      {
        path: "osourcelist",
        component: () => import("@/components/SiteInner/opensource/opensourceList.vue")
      },
      {
        path: "mdfosource",
        component: () => import("@/components/SiteInner/opensource/mdfOpenSource.vue")
      },
      {
        path: "addosource",
        component: () => import("@/components/SiteInner/opensource/addOpenSource.vue")
      }
    ]
  },
  {
    path: '/help',
    name: '帮助',
    //redirect: "/news/index",//默认加载某个页面
    children: [
      {
        //二级导航路径不要加 /
        path: "helptype",
        component:  () => import("@/components/SiteInner/help/helpType.vue"),
      },
      {
        path: "helplist",
        component: () => import("@/components/SiteInner/help/helpList.vue")
      },
      {
        path: "addhelpinfo",
        component: () => import("@/components/SiteInner/help/addHelpInfo.vue")
      },
      {
        path: "mdftype",
        component: () => import("@/components/SiteInner/help/mdfType.vue")
      }
    ]
  },
  {
    path: '/order',
    name: '工单',
    //redirect: "/news/index",//默认加载某个页面
    children: [
      {
        //二级导航路径不要加 /
        path: "ordertype",
        component:  () => import("@/components/SiteInner/order/orderType.vue"),
      },
      {
        path: "orderlist",
        component: () => import("@/components/SiteInner/order/orderList.vue")
      },
      {
        path: "addorderinfo",
        component: () => import("@/components/SiteInner/order/addOrderInfo.vue")
      },
      {
        path: "mdftype",
        component: () => import("@/components/SiteInner/order/mdfType.vue")
      },
      {
        path: "userorderlist",
        component: () => import("@/components/SiteInner/order/userOrderList.vue")
      },
      {
        path: "uorderchk",
        component: () => import("@/components/SiteInner/order/uorderchk.vue")
      }
    ]
  },
  {
    path: '/test',
    component:  () => import("@/components/SiteInner/order/chat.vue"),
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const token = getTokenFromLocalStorage(); // 从LocalStorage中获取令牌
  //登录路由逻辑
  if ( to.path === '/login') { // 如果用户要进入的是登录页
   
    if (token && !isTokenExpired(token)) { // 如果令牌存在且未过期
      ElNotification({
        title: '您已登录',
        message: '退出登录 请前往个人中心',
        position: 'bottom-right',
        type: 'success',
      });
      // Swal.fire({
      //   title: '您已登录',
      //   icon: 'success',
      //   showConfirmButton: true,
      //   confirmButtonText: '确认',
      // });
        next('/'); // 重定向到主页
    } else {
      removeTokenFromLocalStorage();
        next(); // 处理下一个钩子
    }

// 未登录情况下强制跳转的路由逻辑
}else {
  if (token && !isTokenExpired(token)) { // 如果令牌存在且未过期
    next(); // 允许访问
  } else {
    Swal.fire({
      title: '尚未登录',
      icon: 'error',
      showConfirmButton: true,
      confirmButtonText: '确认',
    });
    next('/login'); // 如果没有有效token，重定向到登录页面
  }
}
});

export default router
